module.exports = __webpack_public_path__ + "img/eyes_female_extra_round_makeup.1bbba5f3.png";